import { render, staticRenderFns } from "./blur-box.vue?vue&type=template&id=71bcabde&scoped=true"
import script from "./blur-box.vue?vue&type=script&lang=js"
export * from "./blur-box.vue?vue&type=script&lang=js"
import style0 from "./blur-box.vue?vue&type=style&index=0&id=71bcabde&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71bcabde",
  null
  
)

export default component.exports